import Category from "@/components/category";
import TeaserDownpull from "@/components/teaser-downpull";
import TeaserHeading from "@/components/teaser-heading";
import TeaserLinkedContent from "@/components/teaser-linked-content";
import { Content } from "@/services/content/types";
import { getEstimatedReadingTime } from "@/utils/getEstimatedReadingTime";
import { createImageSizes, createImageUrl } from "@/utils/image";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";
import Vinjett from "../../vinjett";

type LargeProps = {
  article: Content.Article;
  showLinkedContent?: boolean;
  fullWidth?: boolean;
  largeHeader?: boolean;
  imagePriority?: boolean;
};

const Large = ({
  article,
  showLinkedContent = true,
  fullWidth = false,
  imagePriority = false,
}: LargeProps) => {
  const category = article.fields.categories?.[0];
  const image = article.fields.teaserImage || article.fields.images?.[0];
  const title = article.fields.teaserTitle || article.fields.title;

  const hasLinkedContent = Boolean(article.fields.linkedContent?.length);
  const author = article.fields.authors?.[0];
  const parentCategory = category?.fields.parentCategory;
  const color = category?.fields.color || parentCategory?.fields.color;
  const showByline =
    article.fields.showByline !== undefined ? article.fields.showByline : false;
  const bylineImage =
    article.fields.hideBylineImage !== undefined
      ? article.fields.hideBylineImage
      : false;
  const readTime = getEstimatedReadingTime(article.fields.content);
  const vinjett = article.fields.vinjett;
  const teaserLayoutType = article.fields.teaserLayoutType;
  return (
    <div>
      <Link
        href={`/${article.fields.slug}`}
        className={classNames(
          "group block relative overflow-hidden bg-sand-600 ",
          {
            "": hasLinkedContent,
            "w-screen md:w-auto -ml-4 md:ml-0": fullWidth,
            "border-b border-sand-800":
              teaserLayoutType === "Centrerad rubrik" && hasLinkedContent,
          },
        )}
      >
        {vinjett && <Vinjett content={vinjett} />}
        {image?.fields?.file?.url && (
          <div className="aspect-w-16 aspect-h-9">
            <Image
              priority={imagePriority ? true : false}
              fill
              quality={90}
              src={createImageUrl(image.fields.file.url, { crop: "16:9" })}
              alt={image.fields.alt || ""}
              className="object-cover"
              sizes={createImageSizes({
                mobile: "100vw",
                tablet: "50vw",
                desktop: "33vw",
              })}
            />
          </div>
        )}

        <div className="p-4">
          <div className="flex flex-col">
            {category && (
              <Category
                category={category}
                centered={teaserLayoutType === "Centrerad rubrik"}
              />
            )}
          </div>
          {title && (
            <TeaserHeading
              text={title}
              className={classNames(
                "text-4xl md:text-5xl font-normal",
                teaserLayoutType === "Centrerad rubrik" ? "text-center" : "",
              )}
            />
          )}
          <TeaserDownpull
            showByline={showByline}
            authorName={author?.fields.name}
            excerpt={article.fields.excerpt}
            showbyLineImage={bylineImage}
            centered={teaserLayoutType === "Centrerad rubrik"}
          />
        </div>
      </Link>
      {showLinkedContent && hasLinkedContent && (
        <div
          className={classNames(
            "border-b border-b-sand-800 bg-sand-600 -mt-4 last:border-0 p-4",
            {
              "w-screen md:w-auto -ml-4 md:ml-0": fullWidth,
            },
          )}
        >
          <TeaserLinkedContent
            linkedContent={article.fields.linkedContent}
            showLinkedContent={hasLinkedContent}
            compactMode={false}
            interviewMode={true}
          />
        </div>
      )}
    </div>
  );
};

export default Large;
